import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles.scss'

const StageIndicator = ({
  stages,
  currentStage,
  settings,
}) => {
  const activeIdx = stages.findIndex(stage => stage.id === currentStage)
  const firstVisible = stages.findIndex(stage => stage.visible !== false)

  if (activeIdx <= 0 || activeIdx < firstVisible) {
    // Hide the first stage (address search)
    // Also hide if the stage was not found or is not visible
    return null
  }

  const stagesFiltered = stages.map((stage, idx) => ({ ...stage, idx }))
    .filter(stage => stage.visible !== false)
  const stageElements = stagesFiltered.map(stage => (
    <div
      key={stage.id}
      className={classNames(
          styles.stage,
          {
            [styles.current]: stage.id.indexOf(currentStage) !== -1,
            [styles.complete]: stage.idx < activeIdx,
          },
        )}
    >
      <div
        className={styles.icon}
      />
      <span className={styles.title}>{settings[stage.id]}</span>
    </div>
  ))

  return (
    <div className={`stageIndicatorGlobal ${styles.wrapper}`}>
      {stageElements}
    </div>
  )
}

StageIndicator.propTypes = {
  stages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })).isRequired,
  currentStage: PropTypes.string,
  settings: PropTypes.object,
}

StageIndicator.defaultProps = {
  currentStage: null,
  settings: {},
}

export default StageIndicator



// WEBPACK FOOTER //
// ./components/StageIndicator/index.jsx